import { log, toPercentage } from "../../exports/helpers.js";
export default function keepNumbers(data, key, keepNonNumbersOnly = false, verbose) {
    verbose && log("Keeping only numbers. Excluding NaN values as well.");
    const filteredData = data.filter((d) => {
        const test = typeof d[key] === "number" && !Number.isNaN(d[key]);
        return keepNonNumbersOnly ? !test : test;
    });
    const nbRemoved = data.length - filteredData.length;
    verbose &&
        log(`/!\\ ${nbRemoved} items removed, representing ${toPercentage(nbRemoved, data.length)} of received items.`, "bgRed");
    return filteredData;
}
//# sourceMappingURL=keepNumbers.js.map